<template>
    <thead class="mds-data-table__header">
        <tr class="mds-data-table__row">
            <HeaderCell
                v-for="(config, col) in columnsConfig"
                :key="col"
                v-bind="config"
            >
                <slot
                    name="header-cell"
                    :content="config.text"
                    :col="col"
                >
                    {{ config.text }}
                </slot>
            </HeaderCell>
        </tr>
    </thead>
</template>

<script>
import HeaderCell from '@/components/molecules/data-table/header-cell';

export default {
  components: { HeaderCell },

  props: {
    columnsConfig: { type: Array, default: () => [] },
  },
};
</script>
